import React from "react";
import Article from "./Article";
import "./articles.style.css";
import { ARTICLES_LIST } from "./data";

const Articles = () => {
  return (
    <section
      className="articles"
      id="articles"
      aria-labelledby="articles-heading"
    >
      {/* Heading text unchanged, only semantic level fixed */}
      <h2 className="heading" id="articles-heading">
        Articles
      </h2>

      <div className="article-list">
        {ARTICLES_LIST.map((item) => {
          return <Article key={item.id} item={item} />;
        })}
      </div>
    </section>
  );
};

export default Articles;
